import { render, staticRenderFns } from "./morningmeetingStudentDetail.vue?vue&type=template&id=4b818d52&"
import script from "./morningmeetingStudentDetail.vue?vue&type=script&lang=js&"
export * from "./morningmeetingStudentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports